import { render } from "./secondaryStudentdetails.vue?vue&type=template&id=c046109e&scoped=true"
import script from "./secondaryStudentdetails.vue?vue&type=script&lang=js"
export * from "./secondaryStudentdetails.vue?vue&type=script&lang=js"

import "./secondaryStudentdetails.vue?vue&type=style&index=0&id=c046109e&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/2026_cdf/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c046109e"]])

export default __exports__